import { BaseQueryFn } from '@reduxjs/toolkit/query'
import { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios'
import api from '../../api'
import { useFormik } from 'formik'

interface Params {
    url: string
    params?: AxiosRequestConfig['params']
    body?: AxiosRequestConfig['data']
    method: 'GET' | 'POST' | 'PATCH' | 'PUT' | 'DELETE'
}

type BaseQueryResponse = BaseQueryFn<Params, unknown, unknown>

type BaseQueryErrorResponse = {
    status: number
    data: any
}

export default function baseQuery(): BaseQueryResponse {
    return async function (args: Params) {
        try {
            const params = args.params || args.body

            const response: AxiosResponse = await api.sentRequest(
                args.url,
                params,
                false,
                null,
                null,
                args.method,
                'application/json'
            )

            return {
                data: response.data
            }
        } catch (axiosError) {
            const error = axiosError as AxiosError

            return {
                error: {
                    status: error.response?.status,
                    data: error.response?.data || error.message
                }
            }
        }
    }
}

export function parseLaravelError(
    error: BaseQueryErrorResponse,
    form?: ReturnType<typeof useFormik>
) {
    if (error.status === 422) {
        const errors = error.data.errors
        const message = error.data.message as string

        if (!errors || !message) {
            const errorObject = { message: 'An error occurred', type: 'error' }

            form?.setStatus(errorObject)

            return errorObject
        }

        const formErrors: Record<string, string> = {}

        Object.keys(errors).forEach((key) => {
            formErrors[key] = errors[key][0]
        })

        form?.setErrors(formErrors)

        const errorObject = { message, type: 'error' }

        form?.setStatus(errorObject)

        return errorObject
    } else {
        const message =
            error.data.message ||
            'Something went wrong. Please try again later.'

        const errorObject = {
            message,
            type: 'error'
        }

        if (error.data && error.data.message) {
            errorObject.message = error.data.message
        }

        form?.setStatus(errorObject)

        return errorObject
    }
}
